<div *ngIf="show" class="modal-background" id="termsModal">
  <div class="modal-frame">
    <div class="modal-frame-body pad-4 pad-r-2">
      <p class="title-color">{{'COMMON.USAGECONDITION' | translate }}</p>
      <div class="modalBodyUx">
        <div>
          <div class="text-box" [innerHTML]="('LEGAL.' + clientId + '.MODAL') | translate"></div>
          <div class="acceptRow">
            <form [formGroup]="checkboxFrom">
              <label class="containerCheckbox">
                <input type="checkbox" id="termsCheckbox" formControlName="acceptTerms">
                <span class="checkmark"></span>
                <span class="font-size-custom" [innerHTML]="('LEGAL.' + clientId + '.ACCEPTLEGALTERMS' | translate)"></span>
              </label>
            </form>
          </div>
        </div>

          <button
            [class]="(!checkboxFrom.controls.acceptTerms.value) ? 'btn btn-primary disabledButton': 'btn btn-primary'"
            [disabled]="checkboxFrom.controls.acceptTerms.value===''" id="btnAcceptTerms" (click)="sendAcceptTerms()"
            type="submit"> {{ 'COMMON.ACCEPT' | translate | lowercase }}
          </button>
      </div>
    </div>
  </div>
</div>
